/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
import jwtDecode from "jwt-decode";
import Cookies from "universal-cookie";
import Moment from "react-moment";

import { Tooltip, Typography, Popconfirm } from "antd";
const { Paragraph } = Typography;

const cookies = new Cookies();

export const getUserAndPremiseId = () => {
  const getPremiseId = localStorage.getItem("userId");
  const premise = JSON.parse(getPremiseId);
  const userInfo = premise?.userInfo;
  return userInfo;
};

export const getRemainingTimeForToken = () => {
  const token = localStorage.getItem("userinfo");

  if (token) {
    const decodedToken = jwtDecode(token);
    return (decodedToken.exp * 1000 - Date.now()) / 1000;
  }
  return 0;
};

// str => string
// matchingStr => array of matching string or string
export const checkForSetOfStrings = (str, matchingStr) => {
  if (typeof matchingStr === "object") {
    return matchingStr.some((el) => str.includes(el));
  } else if (typeof matchingStr === "string") {
    return str.includes(matchingStr);
  }
  return false;
};

export const isNull = (e) => {
  return e ? e + ", " : "";
};

export const isBlank = (e) => {
  return e || "";
};

export const checkNumbervalue = (event) => {
  if (!/^[0-9]*\.?[0-9]*$/.test(event.key) && event.key !== "Backspace") {
    return true;
  }
};

export const checkSpecialCharacter = (event) => {
  if (!/^[A-Za-z0-9 ]+$/.test(event.key) && event.key !== "Backspace") {
    return true;
  }
};

export const checkSpace = (event) => {
  if (!/^\S+$/.test(event.key) && event.key !== "Backspace") {
    return true;
  }
};

export const checkEditable = (event) => {
  if (event.target.value.length < 10) {
    return true;
  }
};

export const checkAlphaAndComma = (event) => {
  if (!/^[a-zA-Z,]+$/.test(event.key)) {
    return true;
  }
};

export const checkAlphabets = (event) => {
  if (!/^[a-zA-Z- ]*$/.test(event.key) && event.key !== "Backspace") {
    return true;
  }
};

export const checkAlphabetsAndNumber = (event) => {
  if (
    !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
      event.key
    ) &&
    event.key !== "Backspace"
  ) {
    return true;
  }
};

export const scrollToTop = (selector) => {
  const elem = document.querySelector(selector);
  elem?.scrollTo(0, 0);
};

export const gstNumber = (event) => {
  if (
    !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
      event.key
    ) &&
    event.key !== "Backspace"
  ) {
    return true;
  }
};

export const panNumber = (event) => {
  if (
    !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(event.key) &&
    event.key !== "Backspace"
  ) {
    return true;
  }
};

export const getUserTokenCookie = () => {
  return cookies.get("userToken");
};

export const getUserEmail = () => {
  return cookies.get("userToken");
};

//overflow ellipsis for long text
export const overflowFunc = (text, width) => {
  return (
    <Tooltip title={text} placement="bottomLeft">
      <Paragraph ellipsis style={{ width }}>
        {text && text}
      </Paragraph>
    </Tooltip>
  );
};

//Serial Number for tables
export const serialNum = (pageSize, pageNum, index) => {
  let serialNum = pageSize * (pageNum == 0 ? pageNum : pageNum - 1) + index + 1;
  return serialNum;
};

// Date format
export const dateFormat = (dateToFormat) => {
  const toUpperCaseFilter = (d) => {
    return d.slice(0, 10);
  };
  return <Moment format="DD/MM/YYYY">{dateToFormat}</Moment>;
};

//All words will be upperCase
export const capitalise = (e) => {
  let splitStr = e?.target?.value?.toLowerCase()?.split(" ");
  for (let i = 0; i < splitStr?.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr?.join(" ");
};

//Only first word will be uppercase
export const firstLetterCapitalise = (e) => {
  let str = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
  return str;
};

export const firstLetterCapitaliseDropDown = (e) => {
  let str = e.charAt(0).toUpperCase() + e.slice(1);
  return str;
};
export const firstLetterCapsInSentence = (a) => {
  let str = a.split(" ")[0].charAt(0).toUpperCase() + a.slice(1).toLowerCase();
  return str;
};

///Camel Case///
export const camelCase = (e) => {
  let str = e
    ?.split(" ")
    .map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase())
    .join(" ");
  return str;
};
//--//

///Capitalize///
export const capitalize = (e) => {
  let str = e
    ?.split(" ")
    .map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase())
    .join(" ");
  return str;
};
export const capitalizeWithComma = (e) => {
  let str = e
    ?.split(",")
    .map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase())
    .join(",");
  return str;
};

export const capitaliseWithHyphen = (e) => {
  let a = [" ", "-", "_"];
  // let y = "HI-There is An ERRor-but OKaY buT_its_not_FINE";
  let y = e;
  y = y.toLowerCase();
  let x = "";
  for (let i = 0; i < y.length; i++) {
    if (i == 0) {
      x += y[0].toUpperCase();
    } else {
      if (a.includes(y[i])) {
        x += y[i];
        x += y[i + 1].charAt(0).toUpperCase() + y[i + 1].slice(1).toLowerCase();
        i++;
      } else {
        x += y[i];
      }
    }
  }
  return x;
};

export const convertDate = (date1) => {
  if (date1) {
    var date = new Date(date1);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
  } else {
    return "NA";
  }
};
//--//

//Disbale Next Date
